import React, { FC, Fragment, ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs as MuiTabs } from '@material-ui/core';

import { UserStatus } from 'api';
import { LargeTab } from 'components';

interface IProps {
  filter: string;
  onChange: (value: UserStatus) => void;
}

const Tabs: FC<IProps> = props => {
  const { filter, onChange } = props;
  const { t } = useTranslation();

  function handleChange(event: ChangeEvent, value: UserStatus) {
    onChange(value);
  }

  return (
    <MuiTabs value={filter} onChange={handleChange}>
      <LargeTab label={<Fragment>{t('common:active')}</Fragment>} value={UserStatus.Active} />
      <LargeTab label={<Fragment>{t('admin:suspended')}</Fragment>} value={UserStatus.Disabled} />
    </MuiTabs>
  );
};

export default Tabs;
